'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;


//////////////////
// WEBPACK FOOTER
// ./~/history/lib/ExecutionEnvironment.js
// module id = 385
// module chunks = 0